import { checkValue } from 'helpers/timeHelpers';
import { useWindowEvent } from 'hooks';
import React, { useRef } from 'react';
import styled from 'styled-components';

import {
	defaultInputStyles,
	FormGroup,
	inputTransition,
	Label
} from './styles';

const StyledDobInput = styled.input`
  ${() => defaultInputStyles()}
  ${() => inputTransition()}
  position: relative;

  &::placeholder {
    opacity: 0;
  }
  &:focus::placeholder{
    opacity: 1;
  }
`;

const DobInput = ({
	type, name, value, label, required, onChange, className,
}) => {
	const myRef = useRef(null);
	function handleChange(e) {
		let { value } = e.target;
		value = value.toString();
		if (/\D\/$/.test(value)) value = value.substr(0,
			value.length - 3);
		let values = value.split('/').map((val) => val.replace(/\D/g,
			''));

		if (values[0]) values[0] = checkValue(values[0],
			12);
		if (values[1]) values[1] = checkValue(values[1],
			31);
		const output = values.map((val, idx) => val.length == 2 && idx < 2 ? val + ' / ' : val);
		let dobStr = output.join('').substr(0,
			14);
		onChange(dobStr);
	}

	function getYear(values) {
		let currentYear = JSON.stringify(new Date().getFullYear()).split('').slice(2).join(''),
			inputYear = parseInt(values[2]),
			century = 1900;
		if (values[2].length !== 4) {
			if (inputYear < currentYear) {
				century = 2000
			}
			return inputYear + century;
		}
		return inputYear
	}

	function handleBlur (e) {
		const { value } = e.target;
		let values = value.split('/').map((val) => val.replace(/\D/g,
			''));
		let output = '';

		if (values.length == 3) {
			let year = getYear(values);
			let month = parseInt(values[0]) - 1;
			let day = parseInt(values[1]);
			let d = new Date(year,
				month,
				day);
			if (!isNaN(d)) {
				let dates = [d.getMonth() + 1, d.getDate(), d.getFullYear()];
				output = dates.map((val) => {
					val = val.toString();
					return val.length == 1 ? '0' + val : val;
				}).join(' / ');
			}
		}
		onChange(output)
	}

	useWindowEvent('keyup',
		(e) => {
			const charCode = e.which ? e.which : e.keyCode;

			if (document.activeElement !== myRef.current) {
				return true
			}

			if (charCode > 31 && // space or valid character
        charCode !== 127 && // not DEL
        (charCode < 48 || charCode > 57)) { // not 0-9
				if (value && value.length) {
					if (value.length === 1) {
						onChange(`0${value} /`)
					} else if (value.length === 6) {
						console.log('value',
							value)
						let val = value.split('');
						let lastVal = val.pop();
						let finString = val.join('')
						finString += `0${lastVal} / `
						onChange(finString)
					}
				}
			}
		});

	return (
		<FormGroup>
			<StyledDobInput
				className={`${className} ${value && 'filled'}`}
				type={type && type}
				name={name}
				value={value}
				onChange={handleChange}
				onBlur={handleBlur}
				required={required ? true : undefined}
				placeholder="MM/DD/YYYY"
				ref={myRef}
			/>
			<Label htmlFor={name}>{label}</Label>
			<span></span>
		</FormGroup>
	);
};

export default DobInput;
